export enum ActionType {
  SUBSCRIBE,
  UNSUBSCRIBE,
  NONE,
}

export namespace ActionType {
  let elements = [ActionType.SUBSCRIBE, ActionType.UNSUBSCRIBE, ActionType.NONE];
  let alias = "com.bcdfx.api.servicerequest.market.MarketDataRequest.ActionType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
